<template>
  <div>
    <div v-if="!isLoadingPage">
      <div v-if="permission != null">
        <div v-if="permission.read_perm == 1">
          <div style="width: 100%">
            <v-card elevation="0" class="px-3 py-2" style="width: 100%">
              <v-row>
                <v-col
                  cols="12"
                  class="d-flex"
                  style="
                    position: relative;
                    padding: 0 20px;
                    text-align: center;
                    margin-top: 20px;
                  "
                >
                  <h6
                    class="indigo--text"
                    style="font-weight: bold; margin: auto"
                  >
                    DASHBOARD K3 PERFORMANCE REPORT<v-tooltip
                      bottom
                      color="grey"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          x-small
                          text
                          icon
                          color="grey darken-2"
                          @click="getDataFromApi"
                        >
                          <v-icon small>mdi-refresh</v-icon>
                        </v-btn>
                      </template>
                      <span>refresh page</span>
                    </v-tooltip>
                  </h6>
                </v-col>
              </v-row>
              <v-row no-gutters class="mt-7">
                <v-col cols="12">
                  <v-row align="center">
                    <!-- <v-col cols="12" md="3">
                      <div class="rm-height">
                        <v-select
                          v-model="selectedCompany"
                          :items="companies"
                          label="Perusahaan"
                          dense
                          class="rm-height"
                        ></v-select>
                      </div>
                    </v-col> -->
                    <v-col cols="12" md="3">
                      <div class="rm-height">
                        <v-text-field
                          v-model="paramAPI.start_date"
                          @change="dateWathcer"
                          type="month"
                          name="month"
                          step="1"
                          label="Dari Bulan"
                          dense
                          outlined
                        />
                      </div>
                    </v-col>
                    <v-col cols="12" md="3">
                      <div class="rm-height">
                        <v-text-field
                          v-model="paramAPI.end_date"
                          @change="dateWathcer"
                          type="month"
                          name="month"
                          step="1"
                          label="Hingga Bulan"
                          dense
                          outlined
                        />
                      </div>
                    </v-col>
                    <v-col cols="12" md="6" class="text-right">
                      <v-btn icon @click="selectMode('table')">
                        <v-icon :color="viewMode === 'table' ? 'primary' : ''"
                          >mdi-table</v-icon
                        >
                      </v-btn>
                      <!-- <v-btn icon @click="selectMode('chart')">
                        <v-icon :color="viewMode === 'chart' ? 'primary' : ''"
                          >mdi-chart-bar</v-icon
                        >
                      </v-btn> -->
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <!-- Table or Chart View -->
              <v-row no-gutters v-if="viewMode === 'table'">
                <v-col cols="12">
                  <!-- <v-card elevation="2">
                    <v-card-text>
                      <v-simple-table dense>
                        <thead>
                          <tr>
                            <th>Item</th>
                            <th class="text-center">Jan</th>
                            <th class="text-center">Feb</th>
                            <th class="text-center">Mar</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, index) in tableData" :key="index">
                            <td :class="row.class">{{ row.label }}</td>
                            <td class="text-center">{{ row.jan }}</td>
                            <td class="text-center">{{ row.feb }}</td>
                            <td class="text-center">{{ row.mar }}</td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-card-text>
                  </v-card> -->
                  <v-card class="pa-4">
                    <!-- <h3>Bulan: {{ paramAPI.start_date }}</h3> -->
                    <v-data-table
                      :headers="headers"
                      hide-default-header
                      :items="result"
                      dense
                      class="elevation-1"
                      :items-per-page="10"
                      height="55vh"
                      mobile-breakpoint="0"
                    >
                      <template v-slot:header="{ props }">
                        <thead>
                          <tr>
                            <th
                              v-for="header in props.headers"
                              :key="header.text"
                              :style="{ width: header.width }"
                            >
                              <div style="text-align: left; width: 70px">
                                {{ header.text }}
                                <v-tooltip
                                  v-if="header.desc"
                                  right
                                  color="primary"
                                  top
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      small
                                      color="primary"
                                      x-small
                                    >
                                      mdi-information-outline
                                    </v-icon>
                                  </template>
                                  <span>
                                    {{ header.desc }}
                                  </span>
                                </v-tooltip>
                              </div>
                            </th>
                          </tr>
                        </thead>
                      </template>
                      <template v-slot:[`item.company_name`]="{ item }">
                        <div
                          style="
                            width: 130px;
                            font-size: 12px;
                            padding: 0;
                            display: flex;
                            flex-direction: row;
                          "
                        >
                          {{ item.company_name }}
                        </div>
                      </template>
                      <!-- <template v-slot:[`item.emergency`]="{ item }">
                        <div
                          style="
                            font-size: 12px;
                            padding: 0;
                            display: flex;
                            flex-direction: row;
                          "
                        >
                          {{ item.emergency }}
                        </div>
                      </template> -->
                      <template v-slot:[`item.workdays`]="{ item }">
                        <div class="item-table">
                          {{ item.workdays }}
                        </div>
                      </template>
                      <template v-slot:[`item.severity_rate`]="{ item }">
                        <div class="item-table">
                          {{ item.severity_rate }}
                        </div>
                      </template>
                      <template v-slot:[`item.mandayloss`]="{ item }">
                        <div class="item-table">
                          {{ item.mandayloss }}
                        </div>
                      </template>
                      <template v-slot:[`item.mtc`]="{ item }">
                        <div
                          class="item-table"
                          :style="
                            item.mtc > 0 ? 'background-color: #ffd000' : ''
                          "
                        >
                          {{ item.mtc }}
                        </div>
                      </template>
                      <template v-slot:[`item.fac`]="{ item }">
                        <div
                          class="item-table"
                          :style="
                            item.fac > 0 ? 'background-color: #fff185' : ''
                          "
                        >
                          {{ item.fac }}
                        </div>
                      </template>
                      <template v-slot:[`item.frequency_rate`]="{ item }">
                        <div class="item-table">
                          {{ item.frequency_rate }}
                        </div>
                      </template>
                      <template v-slot:[`item.total_employee`]="{ item }">
                        <div class="item-table">
                          {{ item.total_employee }}
                        </div>
                      </template>
                      <template v-slot:[`item.lti`]="{ item }">
                        <div
                          class="item-table"
                          :style="
                            item.lti > 0 ? 'background-color: #f4845f' : ''
                          "
                        >
                          {{ item.lti }}
                        </div>
                      </template>
                      <template v-slot:[`item.manhour`]="{ item }">
                        <div class="item-table">
                          {{ setSparator(item.manhour) }}
                        </div>
                      </template>
                      <template v-slot:[`item.fatal`]="{ item }">
                        <div
                          class="item-table"
                          :style="
                            item.fatal > 0 ? 'background-color: black' : ''
                          "
                        >
                          {{ item.fatal }}
                        </div>
                      </template>
                      <template v-slot:[`item.keterangan`]="{ item }">
                        <v-chip x-small dark :color="getKeteranganColor(item)">
                          {{ getKeteranganName(item) }}
                        </v-chip>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </div>
        <v-card
          v-else
          flat
          height="90vh"
          style="display: flex; justify-content: center; align-items: center"
        >
          <v-toolbar-title class="overline">
            You Can't Access This Page</v-toolbar-title
          >
        </v-card>
      </div>
      <v-card
        v-else
        flat
        height="90vh"
        style="display: flex; justify-content: center; align-items: center"
      >
        <v-toolbar-title class="overline">
          You Can't Access This Page</v-toolbar-title
        >
      </v-card>
    </div>
    <div v-else>
      <v-card
        class="mx-auto"
        width="100%"
        style="
          z-index: 3;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          position: fixed;
          top: 0;
          height: 100%;
          left: 0;
          right: 0;
          background: rgba(255, 255, 255);
        "
      >
        <v-progress-circular :size="170" :width="10" color="blue" indeterminate
          >Loading...</v-progress-circular
        >
      </v-card>
    </div>
    <!-- <v-card elevation="0" :class="`mt-2 p-5 ${hideChart}`">
      <v-row>
        <v-col cols="12" md="6">
          <canvas ref="manhourChart"></canvas>
        </v-col>
        <v-col cols="12" md="6">
          <canvas ref="pieIncidentChart"></canvas>
        </v-col>
      </v-row>
      <v-row class="mt-5">
        <v-col cols="12" md="6">
          <canvas ref="accidentComparisonChart"></canvas>
        </v-col>
        <v-col cols="12" md="6">
          <canvas ref="mandayLossChart"></canvas>
        </v-col>
      </v-row>
      <v-row class="mt-5">
        <v-col cols="12">
          <canvas ref="propertyDamageChart"></canvas>
        </v-col>
      </v-row>
    </v-card> -->
  </div>
</template>
<script>
import axios from 'axios'
import Chart from 'chart.js'
import buildType from '../../../services/buildType'
import { mapActions, mapGetters, mapMutations } from 'vuex'
const env = process.env.VUE_APP_BUILD_TYPE
export default {
  name: 'dssk3dashboard',
  data: () => ({
    dssApi: buildType.apiURL('dss'),
    eSanqua: buildType.apiURL('esanqua'),
    config: require('../../../services/config.json')[env],
    screenWidth: 0,
    screenHeight: 0,
    isLoadingPage: true,
    permission: null,
    appLevel: null,
    userLevel: null,
    result: [],

    paramAPI: {
      // page: 1,
      // keyword: '',
      // offset: 0,
      // limit: 10,
      // sortBy: 'name',
      // sortType: 'asc',
      start_date: null,
      end_date: null,
      company_id: null
      // department_id: null,
      // level_id: null,
      // section_id: null,
      // itemsPerPage: 10
    },
    dropdown: {
      company: []
    },
    charts: {},
    hideChart: '',
    selectedCompany: 'IMP',
    selectedYear: '2024',
    viewMode: 'table', // or "chart"
    companies: ['IMP', 'ABC', 'XYZ'],
    years: ['2023', '2024', '2025']
  }),
  components: {},
  async mounted() {
    this.$nextTick(() => {
      this.renderCharts()
    })
    this.appLevel = this.config.application.dss.userLevel
    this.appLevel.administrator =
      this.config.application.all.userLevel.administrator

    this.screenWidth = screen.width
    this.screenHeight = screen.height
    this.paramAPI.start_date = new Date().toISOString().slice(0, 7)
    this.paramAPI.end_date = new Date().toISOString().slice(0, 7)
    // this.initChart()
    this.getDataMenu()
  },
  beforeDestroy() {
    Object.values(this.charts).forEach((chart) => {
      if (chart && chart.destroy) chart.destroy()
    })
  },
  computed: {
    // ...mapGetters(['getUserProfile','getDssDasboardQuery'])
    ...mapGetters(['getUserProfile']),

    headers() {
      let arr = []
      arr = [
        { text: 'Plant', value: 'company_name' },
        { text: 'Jumlah Karyawan', value: 'total_employee' },
        // { text: 'Hari Kerja', value: 'workdays' },
        { text: 'Manhour', value: 'manhour', desc: 'Jam kerja' },
        { text: 'FAC', value: 'fac', desc: 'P3K' },
        { text: 'MTC', value: 'mtc', desc: 'Cedera dengan perawatan medis' },
        {
          text: 'LTI',
          value: 'lti',
          desc: 'Cedera menyebabkan hilngnya waktu kerja'
        },
        {
          text: 'Fatal',
          value: 'fatal',
          desc: 'Kecelakaan fatal menyebabkan tidak bisa bekerja kembali'
        },
        {
          text: 'Manday Loss',
          value: 'mandayloss',
          desc: 'Hari kerja yang hilang'
        },
        // { text: 'Emergency', value: 'emergency' },
        {
          text: 'Frequency Rate',
          value: 'frequency_rate',
          desc: 'Frekuensi kecelakaan kerja'
        },
        {
          text: 'Severity Rate',
          value: 'severity_rate',
          desc: 'Tingkat keparahan berdasarkan jumlah hari yang hilang'
        },
        { text: 'Keterangan', value: 'keterangan' }
      ]
      return arr
    }
  },
  methods: {
    ...mapActions(['menu_access', 'getMenuId']),
    ...mapMutations(['setTabs']),
    async dropdownCompany() {
      axios
        .get(`${this.eSanqua}master/universal/plant/dropdown`)
        .then((res) => {
          console.log('company dropdown>>>>>', res.data.data)

          this.dropdown.company = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    dateWathcer(val) {
      console.log(val)
      if (val == null) {
        this.paramAPI.start_date = new Date().toISOString().slice(0, 7)
        this.paramAPI.end_date = new Date().toISOString().slice(0, 7)
      }
      this.getDataFromApi()
    },
    getKeteranganColor(item) {
      if (item.lti > 0) {
        return 'red'
      } else if (item.mtc > 0) {
        return 'orange darken-2'
      } else if (item.fac > 0) {
        return 'yellow darken-2'
      } else if (item.emergency > 0) {
        return 'blue'
      } else {
        return 'green'
      }
    },
    getKeteranganName(item) {
      if (item.fatal > 0) {
        return 'Fatality'
      } else if (item.lti > 0) {
        return 'Major Case'
      } else if (item.mtc > 0) {
        return 'Medical Case'
      } else if (item.fac > 0) {
        return 'Minor Case'
      } else if (item.emergency > 0) {
        return 'Emergency Only'
      } else {
        return 'Zero Accident'
      }
    },
    async getDataMenu() {
      this.isLoadingPage = true
      await this.getMenuId({
        keyword: '',
        path: this.$route.path
      })
        .then((result) => {
          if (result.data.status_code === '00') {
            const menuId = result.data.data[0].id
            this.userLevel = this.getUserProfile.level.find(
              ({ application }) =>
                application.id === this.config.application.dss.applicationId ||
                application.id === this.config.application.all.applicationId
            )
            console.log('userLevel>>>>>', this.userLevel)
            if (this.userLevel !== null) {
              if (
                this.getUserProfile.level.find(
                  ({ id }) => id == this.appLevel.administrator
                ) !== undefined
              ) {
                this.resetPermission({
                  data: {
                    read_perm: 1,
                    create_perm: 1,
                    update_perm: 1,
                    delete_perm: 1
                  }
                })
              } else {
                this.checkMenuAccess([menuId, this.userLevel.id])
              }
            } else {
              this.resetPermission(null)
            }
          } else {
            this.isLoadingPage = false
          }
        })
        .catch((err) => {
          console.log('get menu error >>>> ', err)
          this.isLoadingPage = false
        })
    },

    async checkMenuAccess(payload) {
      await this.menu_access(payload)
        .then((result) => {
          console.log('menuAccess>>>>', result)
          this.resetPermission(result)
        })
        .catch((err) => {
          console.log('checkMenuAccess err >>>>>', err)
          this.resetPermission(null)
        })
    },
    resetPermission(val) {
      this.permission = null

      if (val !== null) {
        if (val.data !== null) {
          if (val.data.read_perm === 1) {
            this.permission = val.data
            this.initDataForLayout()
          }
        }
      }
      this.isLoadingPage = false
    },
    initDataForLayout() {
      if (this.userLevel.user_user_level.allowed_company !== null) {
        if (
          this.userLevel.user_user_level.allowed_company.find(
            ({ id }) => id == this.getUserProfile.employee.company.plant_id
          ) !== undefined
        ) {
          this.paramAPI.company_id = Number(
            this.getUserProfile.employee.company.plant_id
          )
        } else {
          this.paramAPI.company_id = Number(
            this.userLevel.user_user_level.allowed_company[0].id
          )
        }
      } else {
        this.paramAPI.company_id = Number(
          this.getUserProfile.employee.company.plant_id
        )
      }
      // if (this.getDssDasboardQuery != null) {
      //   this.paramAPI = this.getDssDasboardQuery
      // }
      setTimeout(async () => {
        this.dropdownCompany()
        await this.getDataFromApi()
        this.setArrTabs()
      }, 200)
    },
    async getDataFromApi() {
      // this.loading = true
      await this.initDataTable()
        .then((data) => {
          if (data.status_code == '00') {
            const xArray = []
            console.log('data>>>>>', data.data)
            for (let i = 0; i < this.dropdown.company.length; i++) {
              const company = this.dropdown.company[i]
              if (
                company.id != 6 &&
                company.id != 7 &&
                company.id != 5 &&
                company.id != 14 &&
                company.id != 11 &&
                company.id != 16 &&
                company.id != 8 &&
                company.id != 12 &&
                company.id != 13 &&
                company.id != 18
              ) {
                const item = data.data.find(
                  (item) => item.company_id == company.id
                )
                console.log('item>>>>>', item)

                if (item) {
                  xArray.push({
                    company_name: this.getCompanyAlias(company.id),
                    total_employee: item.total_employee,
                    workdays: item.workdays,
                    manhour: this.setSparator(item.manhour),
                    fac: item.fac,
                    mtc: item.mtc,
                    lti: item.lti,
                    fatal: item.fatal,
                    mandayloss: this.setSparator(item.mandayloss),
                    // emergency: item.emergency,
                    frequency_rate: this.setSparator(item.frequency_rate),
                    severity_rate: this.setSparator(item.severity_rate)
                  })
                } else {
                  xArray.push({
                    company_name: this.getCompanyAlias(company.id),
                    total_employee: 0,
                    workdays: 0,
                    manhour: 0,
                    fac: 0,
                    mtc: 0,
                    lti: 0,
                    fatal: 0,
                    mandayloss: 0,
                    // emergency: 0,
                    frequency_rate: 0,
                    severity_rate: 0
                  })
                }
              }
            }
            this.result = xArray
          } else {
            this.result = []
          }
        })
        .catch((err) => {
          console.log(err)
          this.result = []
        })
      // this.skeleton_loading = false
      // this.loading = false
    },
    async initDataTable() {
      let url = `${this.dssApi}performancereport/summary`
      if (this.paramAPI.start_date != null) {
        url += `?start_date=${this.paramAPI.start_date + '-01'}`
      } else {
        url += `?start_date=${new Date().toISOString().slice(0, 7) + '-01'}`
      }
      if (this.paramAPI.end_date != null) {
        const [year, month] = this.paramAPI.end_date.split('-').map(Number)
        const lastDay = new Date(year, month, 0).getDate()
        const formattedEndDate = `${this.paramAPI.end_date}-${String(
          lastDay
        ).padStart(2, '0')}`
        url += `&end_date=${formattedEndDate}`
      } else {
        // Jika end_date null, gunakan bulan saat ini dan hitung tanggal terakhirnya
        const currentDate = new Date()
        const year = currentDate.getFullYear()
        const month = currentDate.getMonth() + 1 // getMonth() dimulai dari 0
        const lastDay = new Date(year, month, 0).getDate()
        const formattedEndDate = `${String(year).padStart(4, '0')}-${String(
          month
        ).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`
        url += `&end_date=${formattedEndDate}`
      }
      return await new Promise((resolve) => {
        axios
          .get(url)
          .then((res) => {
            console.log(res)
            resolve(res.data)
          })
          .catch((err) => {
            console.log(err)
          })
      })
    },
    setArrTabs() {
      const tabsArr = [
        { tab_name: 'Dashboard', path: '/dss/k3/dashboard', isShown: false },
        {
          tab_name: 'Safety Performance',
          path: '',
          sub_tabs: [
            {
              sub_title: 'Performance Report',
              path: '/dss/k3/performancereport'
            },
            {
              sub_title: 'Laporan Insiden',
              path: '/dss/k3/incidentreport'
            },
            {
              sub_title: 'Laporan Leading',
              path: '/dss/k3/leadingreport'
            }
          ],
          isShown: false
        }
      ]
      if (
        this.getUserProfile.level.find(
          ({ id }) =>
            id == this.appLevel.adminK3 || id == this.appLevel.administrator
        ) != undefined
      ) {
        tabsArr.push({
          tab_name: 'Master Data',
          path: '',
          sub_tabs: [
            {
              sub_title: 'Bagian Tubuh',
              path: '/dss/k3/ms/bodypart'
            },
            {
              sub_title: 'Kategori Cidera',
              path: '/dss/k3/ms/injuredcategory'
            },
            {
              sub_title: 'Klasifikasi Kecelakaan',
              path: '/dss/k3/ms/accidentclassification'
            },
            {
              sub_title: 'Kondisi Berbahaya',
              path: '/dss/k3/ms/dangercondition'
            },
            {
              sub_title: 'Leading',
              path: '/dss/k3/ms/leading'
            },
            {
              sub_title: 'Sumber Kecelakaan',
              path: '/dss/k3/ms/accidentsource'
            },
            {
              sub_title: 'Tindakan Berbahaya',
              path: '/dss/k3/ms/dangeraction'
            },
            {
              sub_title: 'Tipe Kecelakaan',
              path: '/dss/k3/ms/accidenttype'
            }
          ],
          isShown: false
        })
      }
      this.setTabs(tabsArr)
    },
    renderCharts() {
      if (this.$refs.manhourChart) {
        this.charts.manhour = this.createManhourChart(this.$refs.manhourChart)
      }
      if (this.$refs.pieIncidentChart) {
        this.charts.pieIncident = this.createPieIncidentChart(
          this.$refs.pieIncidentChart
        )
      }
      if (this.$refs.accidentComparisonChart) {
        this.charts.accidentComparison = this.createAccidentComparisonChart(
          this.$refs.accidentComparisonChart
        )
      }
      if (this.$refs.mandayLossChart) {
        this.charts.mandayLoss = this.createMandayLossChart(
          this.$refs.mandayLossChart
        )
      }
      if (this.$refs.propertyDamageChart) {
        this.charts.propertyDamage = this.createPropertyDamageChart(
          this.$refs.propertyDamageChart
        )
      }
    },
    createManhourChart(ctx) {
      return new Chart(ctx, {
        type: 'bar',
        data: {
          labels: ['Jumlah Karyawan', 'Manhour', 'Manday Loss'],
          datasets: [
            {
              label: 'IMP - 2024',
              data: [132215, 3787976, 123],
              backgroundColor: '#42a5f5'
            }
          ]
        },
        options: {
          responsive: true,
          plugins: {
            title: {
              display: true,
              text: 'Safe Man Hours Jan-Nov 2024'
            }
          }
        }
      })
    },
    createPieIncidentChart(ctx) {
      return new Chart(ctx, {
        type: 'pie',
        data: {
          labels: ['Near Miss', 'First Aid', 'MTC', 'LTI', 'Fatal'],
          datasets: [
            {
              data: [1, 1, 0, 1, 1],
              backgroundColor: [
                '#FFEB3B',
                '#8BC34A',
                '#00BCD4',
                '#F44336',
                '#9C27B0'
              ]
            }
          ]
        },
        options: {
          responsive: true,
          plugins: {
            title: {
              display: true,
              text: 'Data Kecelakaan Jan - Nov 2024'
            }
          }
        }
      })
    },
    createAccidentComparisonChart(ctx) {
      return new Chart(ctx, {
        type: 'bar',
        data: {
          labels: ['TMP', 'IMP', 'KAJ', 'GIT', 'GPP', 'INOPLAS', 'TMP BAWEN'],
          datasets: [
            {
              label: '2023',
              backgroundColor: '#90caf9',
              data: [1, 2, 0, 1, 4, 0, 2]
            },
            {
              label: '2024',
              backgroundColor: '#f44336',
              data: [1, 1, 1, 2, 5, 0, 1]
            }
          ]
        },
        options: {
          responsive: true,
          plugins: {
            title: {
              display: true,
              text: 'Perbandingan Kecelakaan Kerja'
            }
          }
        }
      })
    },
    createMandayLossChart(ctx) {
      return new Chart(ctx, {
        type: 'bar',
        data: {
          labels: ['TMP', 'IMP', 'KAJ', 'GIT', 'GPP', 'INOPLAS', 'TMP BAWEN'],
          datasets: [
            {
              label: '2023',
              backgroundColor: '#4fc3f7',
              data: [7, 27, 0, 0, 60, 0, 3]
            },
            {
              label: '2024',
              backgroundColor: '#ff9800',
              data: [5, 72, 0, 0, 27, 0, 11]
            }
          ]
        },
        options: {
          responsive: true,
          plugins: {
            title: {
              display: true,
              text: 'Perbandingan Data Manday Loss'
            }
          }
        }
      })
    },
    createPropertyDamageChart(ctx) {
      return new Chart(ctx, {
        type: 'bar',
        data: {
          labels: ['TMP', 'IMP', 'KAJ', 'GIT', 'GPP', 'INOPLAS', 'TMP BAWEN'],
          datasets: [
            {
              label: '2023',
              backgroundColor: '#9e9e9e',
              data: [2, 1, 0, 0, 1, 0, 0]
            },
            {
              label: '2024',
              backgroundColor: '#607d8b',
              data: [0, 1, 0, 0, 1, 0, 0]
            }
          ]
        },
        options: {
          responsive: true,
          plugins: {
            title: {
              display: true,
              text: 'Property Damage Perbandingan'
            }
          }
        }
      })
    },
    selectMode(val) {
      this.viewMode = val
      if (val == 'table') {
        this.hideChart = 'hide-chart'
      }
      if (val == 'chart') {
        this.hideChart = ''
      }
    },

    setSparator(val) {
      if (val != undefined) {
        if (val != null) {
          return val.toString().replace(/\B(?<!\\d*)(?=(\d{3})+(?!\d))/g, '.')
        }
      }
      return '0'
    },
    getCompanyAlias(id) {
      switch (id) {
        case 1:
          return 'PT TIRTA MAS PERKASA'
        // return 'PT TMP'
        case 2:
          return 'PT INDOMULTI MAS PERKASA'
        // return 'PT IMP'
        case 3:
          // return 'PT GIT'
          return 'PT GRAHAMAS INTITIRTA'
        case 4:
          return 'PT KENCANA ABADI JAYA'
        // return 'PT KAJ'
        case 5:
          return 'PT WAHANA INTI MAS'
        case 6:
          return 'PT SANQUA MULTI INTERNASIONAL'
        // return 'PT SMI'
        case 7:
          return 'PT TALENTA HEBA PARNITA'
        // return 'PT THP'
        // case 8:
        //   return 'PT. GAI'
        case 9:
          // return 'PT GPP'
          return 'PT GOLDEN PACK PERKASA'
        case 10:
          return 'PT TMP (BAWEN)'
        // case 11:
        //   return 'PT. INOPLAS'
        // case 12:
        //   return 'PT. BPS'
        // case 13:
        //   return 'PT. BPC'
        case 14:
          return 'PT WIM (SAGI)'
        case 15:
          return 'PT KAJ (BANYUWANGI)'
        case 17:
          return 'PT GIT (PASURUAN)'
        case 19:
          return 'PT TMP (SUKOHARJO)'
        case 20:
          return 'PT TMP (PATI)'
        case 21:
          return 'PT GIT (BANYUMAS)'
        case 22:
          return 'PT GIT (SIDOARJO)'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.grey {
  background-color: #e0e0e0;
  font-weight: bold;
}
.red {
  // color: red;
  font-weight: bold;
}
.rm-height {
  height: 45px;
}
.hide-chart {
  height: 0;
  display: none;
}
h3 {
  margin-bottom: 16px;
}
canvas {
  max-width: 100% !important;
}
.item-table {
  border: 1px solid rgba(0, 0, 0, 0.1);
  width: 60px;
  font-size: 12px;
  padding: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
</style>
